import { Reveal, SectionHead, GoldBtn, Particles } from "@/components/Shared";
import { TrophyGlyph } from "@/pages/Home";
import { AWARDS } from "@/data/content";

export default function Awards() {
    return (
        <div data-testid="awards-page">
            <section className="relative pt-40 pb-24 md:pt-52 md:pb-32 overflow-hidden noise text-center"
                style={{ background: "linear-gradient(180deg, #241006 0%, #1A060C 55%, #140409 100%)" }}
                data-testid="awards-hero">
                <Particles density={45} />
                <div className="container-x relative">
                    <Reveal>
                        <span className="eyebrow">Awards Night · 31 January 2027</span>
                        <h1 className="font-display font-medium text-4xl sm:text-6xl lg:text-7xl leading-[1.06] mt-8 max-w-4xl mx-auto">
                            Startup MahaBazaar <span className="gold-text">Awards 2027</span>
                        </h1>
                        <p className="mt-7 text-[0.64rem] sm:text-xs tracking-[0.42em] uppercase text-muted-luxe">
                            Recognising the Courage to Build
                        </p>
                        <div className="mt-12 flex justify-center"><TrophyGlyph className="w-40 md:w-52 floaty" /></div>
                    </Reveal>
                </div>
            </section>

            <section className="py-24 md:py-32">
                <div className="container-x">
                    <SectionHead eyebrow="The Honours" title={<>Nine Awards. <span className="gold-text">One Night of Glory.</span></>}
                        sub="Presented at the gala Awards Night on 31 January 2027 — the closing ceremony of the bazaar." />
                    <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                        {AWARDS.map((a, i) => (
                            <Reveal key={a.name} delay={(i % 3) * 80}>
                                <div className="card-luxe tilt p-8 h-full group" data-testid={`award-card-${i}`}>
                                    <div className="card-glow" />
                                    <div className="flex items-start justify-between">
                                        <div className="w-12 h-14 arch-top border border-[var(--line)] flex items-center justify-center group-hover:border-[var(--gold)] transition-colors">
                                            <a.icon size={20} strokeWidth={1.2} className="text-[var(--gold)]" />
                                        </div>
                                        <span className="font-display text-2xl text-[var(--ivory)]/15 group-hover:text-[var(--gold)]/60 transition-colors">
                                            0{i + 1}
                                        </span>
                                    </div>
                                    <h3 className="font-display text-2xl mt-7 text-[var(--ivory)]">{a.name}</h3>
                                    <p className="mt-3 text-sm text-muted-luxe leading-relaxed">{a.desc}</p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>

            <section className="py-24 md:py-32 noise relative overflow-hidden"
                style={{ background: "linear-gradient(165deg, #26070F 0%, #1C060C 60%, #140409 100%)" }}>
                <Particles density={35} />
                <div className="container-x text-center relative">
                    <SectionHead eyebrow="The Gala" title={<>The Startup MahaBazaar <span className="gold-text">Gala Night</span></>}
                        sub="31 January 2027 · Main Stage — the PitchYatra finale, the 2047 Showcase, and the Awards ceremony under one roof." />
                    <Reveal delay={150}>
                        <div className="mt-12 flex flex-wrap justify-center gap-4">
                            <GoldBtn to="/register" testid="awards-register-btn">Attend the Awards Night</GoldBtn>
                            <GoldBtn to="/programme" variant="outline" testid="awards-programme-btn">View Programme</GoldBtn>
                        </div>
                        <p className="mt-10 text-[0.6rem] tracking-[0.3em] uppercase text-muted-luxe">
                            Jury, nominees and recipients to be announced
                        </p>
                    </Reveal>
                </div>
            </section>
        </div>
    );
}
